import React, { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import './headerI+D+I.scss'
import FondoHeader from '../../../media/img/i+d+i/representacion-de-la-experiencia-del-usuario-y-diseno-de-la-interfaz.jpg'

const HeaderIDI = () => {
    const { t } = useTranslation();
    const lineRefs = useRef([]);

    useEffect(() => {
        const observerOptions = {
            threshold: 0.2,
            rootMargin: '0px 0px 0px 0px'
        };

        const lineObservers = lineRefs.current.map((lineRef) => {
            if (!lineRef) return null;

            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('content__title-line--visible');
                        observer.unobserve(entry.target);
                    }
                });
            }, observerOptions);

            observer.observe(lineRef);
            return observer;
        });



        return () => {
            lineObservers.forEach(obs => obs?.disconnect());
        };
    }, []);
    return (
        <div>
            <div className="main-content__header">
                <div className="main-content__img-container">
                    <img className="main-content__img" src={FondoHeader} alt="" />
                </div>
                <div className="main-content__lineatop"></div>
                <div className="main-content__lineabottom"></div>
                <div className='main-content__text'>
                    <div>
                        <h1 className="main-content__title ">{t('idi.header.title')}</h1>
                    </div>
                    <div
                        ref={el => lineRefs.current[0] = el}
                        className="content__title-line"
                    />
                    <div>
                        <p className="header-subtitle__main-page">{t('idi.header.subtitle')}</p>
                    </div>
                    <div >
                        <p className="header-text__main-page">
                            {t('idi.header.description')}
                        </p>
                    </div>
                </div>
                <div />
            </div>
        </div>
    )
}

export default HeaderIDI

